import React, { useState } from "react";
import Moment from "moment";
import Icon from "components/blocks/Icon/Icon";
import "./Cards.scss";
import "../CommsList/CommsList.scss";

const PAGE_SIZE_DEFAULT = 5;

const getFileExt = (name: string): string => {
  const m = name?.match(/\.([a-zA-Z0-9]{1,5})$/);
  return m ? m[1].toUpperCase() : "";
};

export interface DocsCardsProps {
  items: any[];
  getName: (item: any) => string;
  getDate?: (item: any) => string | Date | null | undefined;
  getTag?: (item: any) => string;
  getIcon?: (item: any) => string;
  onDownload: (item: any, e: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>;
  loading?: boolean;
  pageSize?: number;
  downloadLabel?: string;
  emptyMessage?: string;
}

const DocsCards: React.FC<DocsCardsProps> = ({
  items,
  getName,
  getDate,
  getTag,
  getIcon,
  onDownload,
  loading = false,
  pageSize = PAGE_SIZE_DEFAULT,
  downloadLabel = "Descargar",
  emptyMessage = "No hay documentos disponibles.",
}) => {
  const [page, setPage] = useState(1);

  if (loading) {
    return <p className="cards-empty">Cargando documentos…</p>;
  }

  if (!items?.length) {
    return <p className="cards-empty">{emptyMessage}</p>;
  }

  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const safePage = Math.min(page, totalPages);
  const paged = items.slice((safePage - 1) * pageSize, safePage * pageSize);

  return (
    <div>
      <div className="cards-list">
        {paged.map((item, i) => {
          const name = getName(item) ?? "";
          const date = getDate ? getDate(item) : null;
          const tag = getTag ? getTag(item) : getFileExt(name);
          const icon = getIcon ? getIcon(item) : "file-text";

          return (
            <article key={i} className="item-card item-card--compact">
              <div className="item-card__icon">
                <Icon name={icon} size={22} />
              </div>
              <div className="item-card__content">
                <div className="item-card__title">{name}</div>
                <div className="item-card__meta">
                  {tag && <span className="item-card__sub">{tag}</span>}
                  {date && Moment(date).isValid() && (
                    <span className="item-card__sub">
                      {Moment(date).format("DD MMM YYYY")}
                    </span>
                  )}
                </div>
              </div>
              <div className="item-card__action">
                <button
                  className="item-card__download-btn"
                  onClick={(e) => onDownload(item, e)}
                  title={downloadLabel}
                >
                  <Icon name="download" size={14} />
                  {downloadLabel}
                </button>
              </div>
            </article>
          );
        })}
      </div>

      <div
        className="comms-list__pager"
        style={{ visibility: totalPages > 1 ? "visible" : "hidden" }}
      >
        <span className="comms-list__pager-info">
          {(safePage - 1) * pageSize + 1}–{Math.min(safePage * pageSize, items.length)} de {items.length}
        </span>
        <div className="comms-list__pager-btns">
          <button
            className="btn btn--ghost btn--sm"
            disabled={safePage <= 1}
            onClick={() => setPage(safePage - 1)}
          >
            <Icon name="arrow-left" size={16} /> Anterior
          </button>
          <button
            className="btn btn--ghost btn--sm"
            disabled={safePage >= totalPages}
            onClick={() => setPage(safePage + 1)}
          >
            Siguiente <Icon name="arrow-right" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocsCards;
